// @core/api/endpoints/localization/create_namespace.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateNamespaceRequest,
  NamespaceResponse,
} from '../../../types/localization';

const BASE_PATH = '/localization';

/**
 * Create translation namespace
 * Creates a namespace for grouping translation keys. Products typically create their namespaces on startup.
 */
export async function CreateNamespace(
  data: CreateNamespaceRequest,
  options?: RequestOptions
): Promise<NamespaceResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/localization/namespaces`;
  const requestOptions = options;
  return client.post<NamespaceResponse>(requestPath, data, requestOptions);
}
